/* eslint react/jsx-props-no-spreading: off */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import routes from './constants/routes.json';
import App from './containers/App';
import HomePage from './containers/HomePage';
import PrivacyPage from './containers/PrivacyPage';
import WorkflowPage from './containers/WorkflowPage';


// // Lazily load routes and code split with webpack
// const LazyWorkflowPage = React.lazy(() =>
//   import(/* webpackChunkName: "WorkflowPage" */ './containers/WorkflowPage')
// );

// const WorkflowPage = (props: Record<string, any>) => (
//   <React.Suspense fallback={<h1>Loading...</h1>}>
//     <LazyWorkflowPage {...props} />
//   </React.Suspense>
// );

export default function Routes() {
  return (
    <App>
      <Switch>
        <Route path={routes.WORKFLOW} component={WorkflowPage} />
        <Route path={routes.PRIVACY} component={PrivacyPage} />
        <Route path={routes.HOME} component={HomePage} />
      </Switch>
    </App>
  );
}
